import React, { useState, useCallback, memo } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = useCallback(() => {
    setIsMenuOpen(prev => !prev);
  }, []);

  const closeMenu = useCallback(() => {
    setIsMenuOpen(false);
  }, []);


  return (
    <header className="bg-white shadow-sm sticky top-0 z-50" itemScope itemType="https://schema.org/Organization">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <Link to="/" data-discover="true" itemProp="url" className="flex items-center gap-2">
              <img src="/images/favicon.webp" alt="Lyon Picks" itemProp="logo" width="32" height="32" className="h-8 w-8" />
              <span className="text-2xl font-bold text-purple-700" itemProp="name">Lyon Picks</span>
            </Link>
          </div>
          
          <nav className="hidden md:flex space-x-8">
            <Link to="/" data-discover="true" className="text-gray-700 hover:text-purple-600 transition">Accueil</Link>
            <Link to="/guides" data-discover="true" className="text-gray-700 hover:text-purple-600 transition">Guides</Link>
            <Link to="/reviews" data-discover="true" className="text-gray-700 hover:text-purple-600 transition">Avis</Link>
            <Link to="/news" data-discover="true" className="text-gray-700 hover:text-purple-600 transition">Actualités</Link>
          </nav>

          <button
            className="md:hidden text-gray-700"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {isMenuOpen && (
          <nav className="md:hidden py-4 space-y-4">
            <Link to="/" data-discover="true" onClick={closeMenu} className="block text-gray-700 hover:text-purple-600">Accueil</Link>
            <Link to="/guides" data-discover="true" onClick={closeMenu} className="block text-gray-700 hover:text-purple-600">Guides</Link>
            <Link to="/reviews" data-discover="true" onClick={closeMenu} className="block text-gray-700 hover:text-purple-600">Avis</Link>
            <Link to="/news" data-discover="true" onClick={closeMenu} className="block text-gray-700 hover:text-purple-600">Actualités</Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export default memo(Header);

